import { ADD_INSTRUCTION, FETCH_TRAINER_INSTRUCTIONS, EDIT_INSTRUCTION } from "../actionTypes"

const initialState = {
  trainer: [],
  corporate: []
};
export default (state = initialState, action=null) => {
  let { type, user, payload } = action;
  switch(type) {
    case ADD_INSTRUCTION:
    case EDIT_INSTRUCTION:
      return {
        ...state,
        [user]: { ...state[user], ...payload }
      }
    case FETCH_TRAINER_INSTRUCTIONS:
      return {
        ...state,
        trainer: {...payload}
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/instructions.js